<template>
  <div>
   <div id="mC">

    <div  id="header" >

      <div  id="menuContainerL" title="Home">
        <img id="iconHome"  @click= "btnHome"  src="/dist/logo-header2.png"  />
      </div>

      <div  id="menuContainerR" >

          <div class="dropdown" @mouseover='showDropPedidos' @mouseleave='hideDropPedidos'>
            <span id="menuPedido" >Pedidos</span>
              <div id="myDropdown" class="dropdown-content"  v-show='dropPedidos' >
                <router-link :to="{name: 'realizarPedido'}">Nuevo Pedido</router-link>
                <div  class="separator-menu" >  </div>
                <router-link :to="{name: 'estadoPedido'}">Estado de Pedidos</router-link>
              </div>
          </div>

         <div id="carritoItemsGlobe" v-show='itemsCarrito!=0' @click= "btnCarrito">
           <span id="carritoCantItem"  v-show='itemsCarrito!=0' style="color:#4969B2; font-weight: 500; font-size: 12px"  >{{itemsCarrito}}</span>
         </div>
         <img  id="iconCarrito" class="icon" @click= "btnCarrito"  src="/dist/carrito.svg" />

         <div class="dropdown" @mouseover='showDropUsuario' @mouseleave='hideDropUsuario'>
          <span id="usuario">{{nombreUsuario}}</span>
          <div id="avatarGlobe">
            <span id="avatarChar" style="color:#4969B2; font-weight: 700; font-size: 18px ">{{letraNombreUsuario}}</span>
          </div>
          <div  class="dropdown-content-b"  v-show='dropUsuario' >
            <router-link :to="{name: 'configuracion'}">Cambiar contraseña</router-link>
            <div  class="separator-menu" >  </div>

            <!--<router-link :to="{name: 'cuentaCorriente'}">Cuenta Corriente</router-link>
            <div  class="separator-menu" >  </div>-->

            <a href="#cerrar" @click="cerrarSesion">Cerrar sesión</a>
          </div>
        </div>

      </div>

    </div>

    </div>

    <div  class="separator" >  </div>
  </div>
</template>






<script>
import axios from 'axios'


export default {
  name: 'sales-header',


  data () {
    return {
      dropPedidos: false,
      dropUsuario: false
    }
  },



  computed: {

    itemsCarrito () {
      return this.$store.state.pedido.carrito.length;
    },

    nombreUsuario () {
      return this.$store.state.user.clienteNombre;
    },

    letraNombreUsuario () {
      return this.$store.state.user.clienteNombre.charAt(0);
    }

  },


  methods: {

    btnCarrito() {
      if (this.itemsCarrito > 0)
      {
        this.$router.push({ name: 'pedido' });
      }
      else
      {
        this.$store.commit('pedido/setBorradorId',0);
        this.$router.push({ name: 'realizarPedido' });
      }
    },

    btnHome() {
      this.$router.push({ name: 'home' });
    },

    showDropPedidos() {
      this.dropPedidos = true;
    },

    hideDropPedidos() {
      this.dropPedidos = false;
    },

    showDropUsuario() {
      this.dropUsuario = true;
    },

    hideDropUsuario() {
      this.dropUsuario = false;
    },


    cerrarSesion() {
        axios.put('/WebSalesLogin',{},{
         headers:{
                   Token:this.$store.state.user.token,
                   ClientSecret: process.env.CLIENT_SECRET,
                   EmpresaId: process.env.EMPRESA_ID
                  }
         }
        ).then((response) => {
         if (response.data.Code == 0)
         {
           this.$access('any')
           this.$router.push({ name: 'login' })
           this.$store.commit('user/delete');
           this.$store.commit('pedido/delete');
         }
         else if (response.data.Code == 99)
         {
           alert(response.data.Message);
           this.$access('any')
           this.$router.push({ name: 'login' });
           this.$store.commit('user/delete');
           this.$store.commit('pedido/delete');
         }
         else
         {
           alert(">>>>"+response.data.Message);
           console.log(">>>>"+response.data.Message);
           this.$access('any')
           this.$router.push({ name: 'login' });
           this.$store.commit('user/delete');
           this.$store.commit('pedido/delete');
         }
        },(error) => { console.log(error)
            alert(error);  })
      }
     }


}

</script>


<style scoped>

.dropdown {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;

}


.dropdown-content:before {
    content:"";
    position: absolute;
    right: 120px;
    top: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #ffffff transparent;
    z-index:9999;
}

.dropdown-content {
    margin-top: 58px;
    margin-left: 10px;
    position: absolute;
    background-color: #ffffff;
    min-width: 160px;
    border-radius: 5px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
}

.dropdown-content a:hover{
  cursor: pointer;
  color: #000000;
}

.dropdown-content a {
    color: #555555;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-weight: 400;
}

/* ------------------------------------------------------ */


.dropdown-content-b:before {
    content:"";
    position: absolute;
    right: 80px;
    top: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #ffffff transparent;
    z-index:9999;
}

.dropdown-content-b {
    margin-top: 58px;
    margin-left: 30px;
    position: absolute;
    background-color: #ffffff;
    min-width: 160px;
    border-radius: 5px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
}

.dropdown-content-b a:hover{
  cursor: pointer;
  color: #000000;
}

.dropdown-content-b a {
    color: #555555;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    font-size: 12px;
    font-weight: 400;
}






    #mC {
      background-color: #005A9F;
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
    }


    #header {
      width: 700px;
      height: 40px;
      background-color: #005A9F;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    #menuContainerR {
        width: 450px;
        font-size: 10px;
        color: #ffffff;
        background-color: #005A9F;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }

    #menuContainerL {
      width: 250px;
      height: 40px;
      background-color: #005A9F;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }


    #menuPedido {
        padding-right: 40px;
        padding-left: 25px;
        vertical-align: middle;
        font-size: 12px;
    }


    #usuario {
        padding-right: 10px;
        padding-left: 40px;
        vertical-align: middle;
        font-size: 12px;
    }


    #iconHome{
      height: 25px;
    }


    .separator {
        width: 100%;
        height: 1px;
        background-color: #136AAA;
    }


    .separator-menu {
        width: 100%;
        height: 1px;
        background-color: #dddddd;
    }




#carritoItemsGlobe{
  width: 17px;
  height: 17px;
  background:#ffffaa;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}


#avatarGlobe{
  width: 28px;
  height: 28px;
  background:#dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}



#iconCarrito:hover { cursor: pointer; }
#carritoItemsGlobe:hover { cursor: pointer; }
#usuario:hover { cursor: pointer; }
#avatarGlobe:hover { cursor: pointer; }
#iconHome:hover { cursor: pointer; }
.menu:hover { cursor: pointer; }

</style>



// WEBPACK FOOTER //
// src/components/views/header.vue